import ElementPlus from "element-plus"
import locale from "element-plus/es/locale/lang/zh-cn"
import "./element-variables.scss"
import 'element-plus/dist/index.css'

export default (app) => {
  app.use(ElementPlus, { locale });
  return ElementPlus;
}
